(function () {
  const floatingCTA = document.getElementById('floatingCTA');

  if (floatingCTA) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 500) {
        floatingCTA.classList.remove('opacity-0', 'translate-y-8', 'pointer-events-none');
        floatingCTA.classList.add('opacity-100', 'translate-y-0', 'pointer-events-auto');
      } else {
        floatingCTA.classList.add('opacity-0', 'translate-y-8', 'pointer-events-none');
        floatingCTA.classList.remove('opacity-100', 'translate-y-0', 'pointer-events-auto');
      }
    });
  }

  const notifs = ['notif1', 'notif2', 'notif3'].map((id) => document.getElementById(id)).filter(Boolean);
  if (!notifs.length) return;

  let idx = 0;
  let currentNotif = null;

  window.hideNotif = () => {
    if (currentNotif) currentNotif.classList.remove('show');
  };

  function showNotif() {
    hideNotif();
    currentNotif = notifs[idx];
    currentNotif.classList.add('show');
    setTimeout(hideNotif, 5000);
    idx = (idx + 1) % notifs.length;
  }

  setTimeout(() => {
    showNotif();
    setInterval(showNotif, 35000);
  }, 30000);
})();

(function () {
  const track = document.getElementById('sliderTrack');
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  const mainSlider = document.getElementById('mainSlider');
  const lightbox = document.getElementById('lightbox');

  if (!track || !prevBtn || !nextBtn || !mainSlider || !lightbox) return;

  const dots = document.querySelectorAll('.gallery-dot');
  const galleryImages = document.querySelectorAll('.gallery-img');
  const lightboxImage = document.getElementById('lightboxImage');
  const lightboxCounter = document.getElementById('lightboxCounter');
  const lightboxDots = document.querySelectorAll('.lb-dot');
  const lightboxClose = document.getElementById('lightboxClose');
  const lightboxPrev = document.getElementById('lightboxPrev');
  const lightboxNext = document.getElementById('lightboxNext');
  const lightboxBackdrop = document.getElementById('lightboxBackdrop');

  const totalSlides =
    typeof wp_total_images !== 'undefined' && wp_total_images > 0
      ? wp_total_images
      : window.product_data?.images?.length || galleryImages.length;

  let currentSlide = 0;
  let lightboxIndex = 0;

  function updateSlider() {
    track.style.transform = `translateX(-${currentSlide * 100}%)`;
    dots.forEach((dot, i) => {
      dot.classList.toggle('bg-sky', i === currentSlide);
      dot.classList.toggle('bg-mist', i !== currentSlide);
    });
  }

  function nextSlide() {
    currentSlide = (currentSlide + 1) % totalSlides;
    updateSlider();
  }

  function prevSlide() {
    currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
    updateSlider();
  }

  nextBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    nextSlide();
  });

  prevBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    prevSlide();
  });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      currentSlide = parseInt(dot.dataset.index, 10);
      updateSlider();
    });
  });

  let startX = 0;
  track.addEventListener(
    'touchstart',
    (e) => {
      startX = e.touches[0].clientX;
    },
    { passive: true }
  );

  track.addEventListener('touchend', (e) => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) diff > 0 ? nextSlide() : prevSlide();
  });

  function updateLightbox() {
    const imgSrc = galleryImages[lightboxIndex].src;
    lightboxImage.src = imgSrc;
    lightboxCounter.textContent = `${lightboxIndex + 1} / ${totalSlides}`;
    lightboxDots.forEach((dot, i) => {
      dot.classList.toggle('bg-white', i === lightboxIndex);
      dot.classList.toggle('bg-white/30', i !== lightboxIndex);
    });
  }

  function openLightbox(index) {
    lightboxIndex = index;
    updateLightbox();
    lightbox.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.add('hidden');
    document.body.style.overflow = '';
  }

  function lightboxNextSlide() {
    lightboxIndex = (lightboxIndex + 1) % totalSlides;
    updateLightbox();
  }

  function lightboxPrevSlide() {
    lightboxIndex = (lightboxIndex - 1 + totalSlides) % totalSlides;
    updateLightbox();
  }

  mainSlider.addEventListener('click', (e) => {
    if (e.target.classList.contains('gallery-img')) {
      openLightbox(parseInt(e.target.dataset.index, 10));
    } else if (!e.target.closest('button')) {
      openLightbox(currentSlide);
    }
  });

  lightboxClose?.addEventListener('click', closeLightbox);
  lightboxBackdrop?.addEventListener('click', closeLightbox);
  lightboxNext?.addEventListener('click', lightboxNextSlide);
  lightboxPrev?.addEventListener('click', lightboxPrevSlide);

  lightboxDots.forEach((dot) => {
    dot.addEventListener('click', () => {
      lightboxIndex = parseInt(dot.dataset.index, 10);
      updateLightbox();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (lightbox.classList.contains('hidden')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') lightboxNextSlide();
    if (e.key === 'ArrowLeft') lightboxPrevSlide();
  });

  let lbStartX = 0;
  let lbStartY = 0;

  lightbox.addEventListener(
    'touchstart',
    (e) => {
      lbStartX = e.touches[0].clientX;
      lbStartY = e.touches[0].clientY;
    },
    { passive: true }
  );

  lightbox.addEventListener('touchend', (e) => {
    const diffX = lbStartX - e.changedTouches[0].clientX;
    const diffY = lbStartY - e.changedTouches[0].clientY;
    if (Math.abs(diffY) > 80 && Math.abs(diffY) > Math.abs(diffX)) {
      closeLightbox();
    } else if (Math.abs(diffX) > 50) {
      diffX > 0 ? lightboxNextSlide() : lightboxPrevSlide();
    }
  });
})();

(function () {
  const reviewLb = document.getElementById('reviewLightbox');
  if (!reviewLb) return;

  const reviewLbImage = document.getElementById('reviewLbImage');
  const reviewLbUser = document.getElementById('reviewLbUser');
  const reviewLbStars = document.getElementById('reviewLbStars');
  const reviewLbCounter = document.getElementById('reviewLbCounter');
  const reviewLbClose = document.getElementById('reviewLbClose');
  const reviewLbBackdrop = document.getElementById('reviewLightboxBackdrop');
  const reviewLbPrev = document.getElementById('reviewLbPrev');
  const reviewLbNext = document.getElementById('reviewLbNext');
  const reviewLbCta = document.getElementById('reviewLbCta');
  const reviewImages = document.querySelectorAll('.review-img-wrap');

  if (!reviewImages.length) return;

  let reviewLbIndex = 0;

  function generateStars(rating) {
    let stars = '';
    for (let i = 0; i < 5; i++) {
      stars += i < rating ? '<i class="fas fa-star"></i>' : '<i class="fa-regular fa-star"></i>';
    }
    return stars;
  }

  function updateReviewLb() {
    const wrap = reviewImages[reviewLbIndex];
    const img = wrap.querySelector('.review-gallery-img');
    reviewLbImage.src = img.src;
    reviewLbUser.textContent = wrap.dataset.user;
    reviewLbStars.innerHTML = generateStars(parseInt(wrap.dataset.rating, 10));
    reviewLbCounter.textContent = `${reviewLbIndex + 1} / ${reviewImages.length}`;
  }

  function openReviewLb(index) {
    reviewLbIndex = index;
    updateReviewLb();
    reviewLb.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeReviewLb() {
    reviewLb.classList.add('hidden');
    document.body.style.overflow = '';
  }

  reviewImages.forEach((wrap, i) => wrap.addEventListener('click', () => openReviewLb(i)));
  reviewLbClose?.addEventListener('click', closeReviewLb);
  reviewLbBackdrop?.addEventListener('click', closeReviewLb);
  reviewLbCta?.addEventListener('click', closeReviewLb);
  reviewLbPrev?.addEventListener('click', () => {
    reviewLbIndex = (reviewLbIndex - 1 + reviewImages.length) % reviewImages.length;
    updateReviewLb();
  });
  reviewLbNext?.addEventListener('click', () => {
    reviewLbIndex = (reviewLbIndex + 1) % reviewImages.length;
    updateReviewLb();
  });

  document.addEventListener('keydown', (e) => {
    if (reviewLb.classList.contains('hidden')) return;
    if (e.key === 'Escape') closeReviewLb();
    if (e.key === 'ArrowRight') {
      reviewLbIndex = (reviewLbIndex + 1) % reviewImages.length;
      updateReviewLb();
    }
    if (e.key === 'ArrowLeft') {
      reviewLbIndex = (reviewLbIndex - 1 + reviewImages.length) % reviewImages.length;
      updateReviewLb();
    }
  });

  let rStartX = 0;
  let rStartY = 0;

  reviewLb.addEventListener(
    'touchstart',
    (e) => {
      rStartX = e.touches[0].clientX;
      rStartY = e.touches[0].clientY;
    },
    { passive: true }
  );

  reviewLb.addEventListener('touchend', (e) => {
    const diffX = rStartX - e.changedTouches[0].clientX;
    const diffY = rStartY - e.changedTouches[0].clientY;
    if (Math.abs(diffY) > 80 && Math.abs(diffY) > Math.abs(diffX)) closeReviewLb();
    else if (Math.abs(diffX) > 50) {
      reviewLbIndex =
        diffX > 0
          ? (reviewLbIndex + 1) % reviewImages.length
          : (reviewLbIndex - 1 + reviewImages.length) % reviewImages.length;
      updateReviewLb();
    }
  });
})();

(function () {
  const faqItems = document.querySelectorAll('.faq-item');
  if (!faqItems.length) return;

  let activeIndex = -1;

  faqItems.forEach((item, index) => {
    const trigger = item.querySelector('.faq-trigger');
    const content = item.querySelector('.faq-content');
    if (!trigger || !content) return;

    trigger.addEventListener('click', () => {
      if (activeIndex === index) {
        item.classList.remove('active');
        content.classList.add('hidden');
        activeIndex = -1;
      } else {
        faqItems.forEach((fi) => {
          fi.classList.remove('active');
          fi.querySelector('.faq-content')?.classList.add('hidden');
        });
        item.classList.add('active');
        content.classList.remove('hidden');
        activeIndex = index;
      }
    });
  });
})();
